import React, { Component } from 'react'



export default class LazyImg extends Component{
    
    componentDidMount() {
        this.imgonload()
    }
    componentDidUpdate(){
        if(this.imge.src!=this.props.src){
            this.imgonload()
        }
    }

    imgonload=()=>{
        
        const {props} = this
        var imgUrl =props.src;
        var imgObject = new Image();
        imgObject.src = imgUrl;
        imgObject.onload = () => {
            this.imge&&(this.imge.src = imgUrl)
            // this.img.setAttribute('class', 'thumbnails complete');
        }
        imgObject.onerror=()=>{
            this.imge&&props.errimg&&(this.imge.src = props.errimg)
        }
    }

    render(){
        const {props} = this
        return(
            <img className={props.className} ref={(ref)=>this.imge=ref} src={props.loadimg} />
        )
    }
}